import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export const loanTypeMap: Record<LoanType, MapItem> = {
  conventional: { label: 'Conventional' },
  fha: { label: 'FHA' },
  va: { label: 'VA' },
  usda: { label: 'USDA' },
  jumbo: { label: 'Jumbo' },
  other: { label: 'Other' },
}

export const loanTypeArray = [
  { label: 'Conventional', value: 'conventional' },
  { label: 'FHA', value: 'fha' },
  { label: 'VA', value: 'va' },
  { label: 'USDA', value: 'usda' },
  { label: 'Jumbo', value: 'jumbo' },
  { label: 'Other', value: 'other' },
]

export enum LoanTypeEnum {
  CONVENTIONAL = 'conventional',
  FHA = 'fha',
  VA = 'va',
  USDA = 'usda',
  JUMBO = 'jumbo',
  OTHER = 'other',
}

export type LoanType = 'conventional' | 'fha' | 'va' | 'usda' | 'jumbo' | 'other'

export const loanTypeSchema = z.nativeEnum(LoanTypeEnum)
